import React from 'react';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Configurations } from '../../Utils/Configurations';
import InputMask from 'react-input-mask';
import axios from 'axios';





class ModalEndereco extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnInput = this.handleOnInput.bind(this);
        this.buscaCEP = this.buscaCEP.bind(this);
        this.salvarEndereco = this.salvarEndereco.bind(this);
        this.handleError = this.handleError.bind(this);
        this.limparModalEndereco = this.limparModalEndereco.bind(this);
        this.habilitaSalvarEndereco = this.habilitaSalvarEndereco.bind(this);

        this.state = {
            exibeEndereco: false,
            isLoadingBuscaCEP: false,
            endereco: this.props.endereco,
            isLoadingSalvarNovoEndereco: false,
            hasError: false,
            cepBusca: '',
            cepDistrital: this.props.cepDistrital,
            logradouro: '',
            bairro: ''

        }

        this.Configurations = new Configurations();
    }

    handleOnInput(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    buscaCEP() {
        this.setState({ isLoadingBuscaCEP: true })
        axios.get(this.Configurations.apiBasePath + `/cep/${this.state.cepBusca}`).then(response => {
            this.setState({
                endereco: response.data.endereco,
                cepDistrital: response.data.endereco.logradouro === ''
            }, () => this.setState({ exibeEndereco: true }))
        }).catch(err => {
            this.setState({ exibeEndereco: false })
        }).finally(() => this.setState({ isLoadingBuscaCEP: false }));
    }

    habilitaSalvarEndereco() {
        const E = this.state.exibeEndereco,
            L = this.state.nome ? this.state.nome.trim() !== '' : false,
            C = this.state.cepBusca ? this.state.cepBusca.trim() !== '' : false,
            N = this.state.numero ? this.state.numero.trim() !== '' : false,
            END = this.state.cepDistrital ? this.state.logradouro !== '' : true,
            B = this.state.cepDistrital ? this.state.bairro !== '' : true
        return !(E * L * C * N * END * B);
    }

    salvarEndereco() {
        const _body = this.state.cepDistrital ? (
            {
                titulo: this.state.nome,
                cep: this.state.endereco.cep.replace("-", ""),
                pais: this.state.endereco.pais,
                uf: this.state.endereco.uf,
                cidade: this.state.endereco.cidade,
                bairro: this.state.bairro,
                logradouro: this.state.logradouro,
                numero: this.state.numero,
                complemento: this.state.complemento,
                codMunicipio: 0
            }
        ) : (
            {
                titulo: this.state.nome,
                cep: this.state.endereco.cep.replace("-", ""),
                pais: this.state.endereco.pais,
                uf: this.state.endereco.uf,
                cidade: this.state.endereco.cidade,
                bairro: this.state.endereco.bairro,
                logradouro: this.state.endereco.logradouro,
                numero: this.state.numero,
                complemento: this.state.complemento,
                codMunicipio: 0
            }

        )
        this.setState({ isLoadingSalvarNovoEndereco: true });
        axios.post(this.Configurations.apiBasePath + `/enderecos/${this.props.idUsuario}`, _body).then(response => {
            this.props.carregarEnderecos();
            this.props.toggle();
            this.limparModalEndereco();
        }).catch(this.handleError).finally(() => { this.setState({ isLoadingSalvarNovoEndereco: false }) })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.erro.message : "Erro inesperado." })
    }

    limparModalEndereco() {
        if (!this.state.ModalEndereco) {
            this.setState({
                endereco: {},
                nome: undefined,
                cepBusca: undefined,
                numero: undefined,
                complemento: undefined,
                exibeEndereco: false,
                logradouro: undefined,
                bairro: undefined
            })
        }
    }

    render() {
        const {
            isOpen,
            toggle
        } = this.props;
        return (
            <Modal className="modal-incluir-endereco" size="lg" isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>Novo endereço</ModalHeader>
                <ModalBody>
                    <div className='row text-left py-2'>
                        <div className='col-12'>
                            <small><p>* informações obrigatórias</p></small>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-6">
                            <label>Nome do novo local <sup>*</sup></label>
                            <input name="nome" className="form-control" onChange={this.handleOnInput} value={this.state.nome} placeholder="Ex: Entrega CILE" autoComplete='off' />
                        </div>
                        <div className='col-6'>
                            <label>CEP <sup>*</sup></label>
                            <div className="row align-items-center">
                                <div className="col-6">
                                    <InputMask
                                        autoComplete="off"
                                        name="cepBusca"
                                        type="tel"
                                        className="form-control m-0"
                                        maskChar=""
                                        id="cep"
                                        mask="99999-999"
                                        placeholder="00000-000"
                                        value={!!this.state.cepBusca ? this.state.cepBusca.substr(0, 9) : ''}

                                        onChange={this.handleOnInput}
                                    />
                                </div>
                                {this.state.isLoadingBuscaCEP ? (
                                    <div className="col-6 text-left">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : (
                                    <div className="col-6 text-left">
                                        <button onClick={this.buscaCEP} className="btn btn-outline-info" autoComplete="off" disabled={!this.state.cepBusca}>buscar CEP</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {this.state.exibeEndereco && (
                        <React.Fragment>
                            <div className="row py-3 align-items-center">
                                {this.state.cepDistrital ? (
                                    <div className="col-6">
                                        <label htmlFor='logradouro'>Endereço <sup>*</sup></label>
                                        <input onChange={this.handleOnInput} name="logradouro" className='form-control' value={this.state.logradouro} autoComplete='off'></input>
                                    </div>
                                ) : (
                                    <div className="col-6">
                                        <label htmlFor="endereco">Endereço</label>
                                        <div className="row">
                                            <div className="col-12 informacoes-endereco">
                                                <strong>{this.state.endereco.logradouro}</strong>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className='col-2'>
                                    <label htmlFor='numero'>Número <sup>*</sup></label>
                                    <input type="text" className="form-control" name="numero" onChange={this.handleOnInput} value={this.state.numero} autoComplete="off" />
                                </div>
                                <div className='col-4'>
                                    <label htmlFor='complemento'>Complemento</label>
                                    <input type="text" className="form-control" name="complemento" onChange={this.handleOnInput} value={this.state.complemento} autoComplete="off" />
                                </div>
                            </div>
                            <div className='row'>
                                {this.state.cepDistrital ? (
                                    <div className='col-4'>
                                        <label htmlFor='bairro'>Bairro <sup>*</sup></label>
                                        <input onChange={this.handleOnInput} name="bairro" className='form-control' autoComplete='off'></input>
                                    </div>
                                ) : (
                                    <div className='col-4'>
                                        <label htmlFor='bairro'>Bairro</label>
                                        <p><strong>{this.state.endereco.bairro}</strong></p>
                                    </div>
                                )}

                                <div className='col-4'>
                                    <label htmlFor='cidade'>Cidade</label>
                                    <p><strong>{this.state.endereco.cidade}</strong></p>
                                </div>
                                <div className='col-2'>
                                    <label htmlFor='uf'>UF</label>
                                    <p><strong>{this.state.endereco.uf}</strong></p>
                                </div>
                                <div className='col-2'>
                                    <label htmlFor='pais'>País</label>
                                    <p><strong>{this.state.endereco.pais}</strong></p>
                                </div>
                            </div>
                            <div className='row text-right'>
                                {this.state.isLoadingSalvarNovoEndereco ? (
                                    <div className='col-12 text-right'>
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : (
                                    <div className='col-12'>
                                        <button className='btn btn-outline-success' onClick={this.salvarEndereco} disabled={!this.state.numero || !this.state.nome || !this.state.cepBusca || this.habilitaSalvarEndereco()}>Salvar</button>
                                    </div>
                                )}

                            </div>
                        </React.Fragment>
                    )}
                </ModalBody>
            </Modal>
        )
    }
}


export default ModalEndereco;